import { readonly, ref } from 'vue';

import type { OrganizationUser } from '@/clients/v1';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const USER_KEY = 'user';

const accessTokenRef = ref<string | null>(localStorage.getItem(ACCESS_TOKEN_KEY));

export const accessToken = readonly(accessTokenRef);

export const getAccessToken = (): string | null => accessTokenRef.value;

export const setAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  accessTokenRef.value = token;
};

export const getRefreshToken = (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY);

export const setRefreshToken = (token: string): void => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

// Throws if the stored value is present but not valid JSON. Callers that want
// to surface that to Sentry should wrap the call in their own try/catch.
export const getStoredUser = (): OrganizationUser | null => {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  return JSON.parse(raw) as OrganizationUser;
};

export const setStoredUser = (user: OrganizationUser): void => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearAuthStorage = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  accessTokenRef.value = null;
};
